import { useMemo } from 'react';
import AttendanceSummaryCards from './AttendanceSummaryCards';
import ReportingLeakageChart from './ReportingLeakageChart';
import DepartmentBarChart from './DepartmentBarChart';
import ShiftWiseBarChart from './ShiftWiseBarChart';
import WorkedDaysDonutChart from './WorkedDaysDonutChart';
import EfficiencyLeakageDonutChart from './EfficiencyLeakageDonutChart';
import LateLoginTable from './LateLoginTable';
import EfficiencyTable from './EfficiencyTable';

const AttendanceReports = ({ filters }) => {
  const mappedFilters = useMemo(
    () => ({
      clientId: filters.client || '',
      scopeId: filters.scope || '',
      employeeId: filters.user || '',
      startDate: filters.startDate || '',
      endDate: filters.endDate || '',
      monthYear: filters.monthYear || '',
    }),
    [filters]
  );

  return (
    <div className="bg-gray-100 min-h-screen py-8 space-y-10 px-6">
      {/* KPI Cards */}
      <div>
        <AttendanceSummaryCards filters={mappedFilters} />
      </div>

      {/* Row 1: Department & Shift-wise Charts */}
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
        <DepartmentBarChart filters={mappedFilters} />
        <ShiftWiseBarChart filters={mappedFilters} />
      </div>

      {/* Row 2: Donut Charts */}
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
        <WorkedDaysDonutChart filters={mappedFilters} />
        <EfficiencyLeakageDonutChart filters={mappedFilters} />
      </div>

      {/* Row 3: Reporting Wise Leakage */}
      <div>
        <ReportingLeakageChart filters={mappedFilters} />
      </div>

      {/* Row 4: Late Login Table */}
      <div>
        <LateLoginTable filters={mappedFilters} />
      </div>

      {/* Row 5: Efficiency Table */}
      <div>
        <EfficiencyTable filters={mappedFilters} />
      </div>
    </div>
  );
};

export default AttendanceReports;
